export default __webpack_public_path__ + "static/media/arrow-triangle-down.a8611a51.svg";